const RegexUtils = {

  browserLocalesFr: /^fr(-[A-Z]{2})?$/i,
  browserLocalesEn: /^en(-[A-Z]{2})?$/i,
  browserLocalesEs: /^es(-[A-Z]{2})?$/i,

  dateTime: /((20\d{2})-(\d{2})-(\d{2})(T?)( ?)(\d{2}):(\d{2}):(\d{2})Z)/,
  dateTimeWithFractionalSeconds: /((20\d{2})-(\d{2})-(\d{2})(T?)( ?)(\d{2}):(\d{2}):(\d{2}).(\d{6})Z)/,
  durationFollowedByMinutes: /(\d+)(?= minutes)/,
  ipv4CidrNotation: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/([1-9]|[12][0-9]|3[012])$/,
  ipv4: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  macAddress: /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/,
  licensePlate: /^[a-zA-Z\d]{4,12}$/,
  keypadCode: /^\d{6}$/,
};

export default RegexUtils;



// WEBPACK FOOTER //
// ./utils/RegexUtils.js